import { Component, OnInit } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { DriverCardService } from '@core/driver-card.service';

marker('tachomat.remove-device.dlk.title-info');
marker('tachomat.remove-device.dlk.title-page');

@Component({
	selector: 'tacho-remove-download-key',
	templateUrl: './remove-download-key.component.html'
})
export class RemoveDownloadKeyComponent implements OnInit {

	constructor(
		readonly cardService: DriverCardService,
	) { }

	ngOnInit() {
		this.cardService.setTitle(
			marker(
				'tachomat.remove-device.dlk.title-page'
			)
		);
		this.cardService.setSubtitle(
			marker(
				'tachomat.remove-device.dlk.title-info'
			)
		);
	}
}
